import { atom } from 'recoil';

const teamNameAtom = atom({
    key: 'teamName',
    default: { name: null, filter: null }
});

export {
    teamNameAtom
};